import React from 'react'
import {FaFacebookF} from 'react-icons/fa'
import {FiInstagram} from 'react-icons/fi'
import { BsLinkedin } from 'react-icons/bs'
import './footer.css'

const Footer = () => {
  return (
    <footer>
    	<p href="#" className='footer__logo'>Thank you for visiting!</p>

		<div className="footer__socials">
			<a href="https://www.facebook.com/tejas.patne.45/"><FaFacebookF /></a>
			<a href="https://instagram.com"><FiInstagram /></a>
			<a href="https://www.linkedin.com/in/tejas-patne-80a018239/"><BsLinkedin /></a>
		</div>

		<div className="footer__copyright">
			<small>&copy; Tejas Patne 2023.</small>
		</div>
    </footer>
  )
}

export default Footer